import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const DessicantAirDryerMaintenanceWidget = ({
  width = 143,
  height = 201,
  fillColor,
  borderColor,
  ...rest
}: {
  width: number;
  height: number;
  fillColor: string;
  borderColor: string;
  [key: string]: unknown;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentFillColor = fillColor ?? token.colorBgContainer;
  const currentBorderColor = borderColor ?? null;

  return (
    <svg width={width} height={height} viewBox="0 0 143 201" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5.5 105.122H3.5C2.39543 105.122 1.5 104.227 1.5 103.122L1.5 95.1223C1.5 94.0177 2.39543 93.1223 3.5 93.1223H5.5L5.5 105.122Z"
        fill={token.colorBorder}
      />
      <g filter="url(#filter0_ddd_24632_1102)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110.5 177.753C110.5 177.753 106.5 177.871 102.446 177.753L102.5 185.808H40.5V177.744C40.5 177.744 36.5005 177.871 32.5 177.744V191.76C32.5 192.856 33.3954 193.744 34.5 193.744H108.5C109.605 193.744 110.5 192.856 110.5 191.76V177.753Z"
          fill={currentFillColor}
          stroke={currentBorderColor}
          strokeDasharray="2 2"
        />
        <path
          d="M67.5 162.244C67.5 158.815 67.5 161.5 67.5 161.5C67.5 161.5 46.7611 161.5 36.5 161.5C26.2389 161.5 5.5 161.5 5.5 161.5C5.5 161.5 5.5 158.815 5.5 162.244C5.5 170.805 19.3792 177.744 36.5 177.744C53.6208 177.744 67.5 170.805 67.5 162.244Z"
          fill={currentFillColor}
          stroke={currentBorderColor}
          strokeDasharray="2 2"
        />
        <path d="M5.5 130.5H67.5V162.5H5.5V130.5Z" fill={currentFillColor} />
        <path
          d="M5.5 130.5H5V131.5H5.5H6V130.5H5.5ZM5.5 133.5H5V135.5H5.5H6V133.5H5.5ZM5.5 137.5H5V139.5H5.5H6V137.5H5.5ZM5.5 141.5H5V143.5H5.5H6V141.5H5.5ZM5.5 145.5H5V147.5H5.5H6V145.5H5.5ZM5.5 149.5H5V151.5H5.5H6V149.5H5.5ZM5.5 153.5H5V155.5H5.5H6V153.5H5.5ZM5.5 157.5H5V159.5H5.5H6V157.5H5.5ZM5.5 161.5H5V162.5H5.5H6V161.5H5.5ZM67.5 162.5H68V161.5H67.5H67V162.5H67.5ZM67.5 159.5H68V157.5H67.5H67V159.5H67.5ZM67.5 155.5H68V153.5H67.5H67V155.5H67.5ZM67.5 151.5H68V149.5H67.5H67V151.5H67.5ZM67.5 147.5H68V145.5H67.5H67V147.5H67.5ZM67.5 143.5H68V141.5H67.5H67V143.5H67.5ZM67.5 139.5H68V137.5H67.5H67V139.5H67.5ZM67.5 135.5H68V133.5H67.5H67V135.5H67.5ZM67.5 131.5H68V130.5H67.5H67V131.5H67.5Z"
          fill={currentBorderColor}
        />
        <path
          d="M137.5 162.244C137.5 158.815 137.5 161.5 137.5 161.5C137.5 161.5 116.761 161.5 106.5 161.5C96.2389 161.5 75.5 161.5 75.5 161.5C75.5 161.5 75.5 158.815 75.5 162.244C75.5 170.805 89.3792 177.744 106.5 177.744C123.621 177.744 137.5 170.805 137.5 162.244Z"
          fill={currentFillColor}
          stroke={currentBorderColor}
          strokeDasharray="2 2"
        />
        <path d="M75.5 130.5H137.5V162.5H75.5V130.5Z" fill={currentFillColor} />
        <path
          d="M75.5 130.5H75V131.5H75.5H76V130.5H75.5ZM75.5 133.5H75V135.5H75.5H76V133.5H75.5ZM75.5 137.5H75V139.5H75.5H76V137.5H75.5ZM75.5 141.5H75V143.5H75.5H76V141.5H75.5ZM75.5 145.5H75V147.5H75.5H76V145.5H75.5ZM75.5 149.5H75V151.5H75.5H76V149.5H75.5ZM75.5 153.5H75V155.5H75.5H76V153.5H75.5ZM75.5 157.5H75V159.5H75.5H76V157.5H75.5ZM75.5 161.5H75V162.5H75.5H76V161.5H75.5ZM137.5 162.5H138V161.5H137.5H137V162.5H137.5ZM137.5 159.5H138V157.5H137.5H137V159.5H137.5ZM137.5 155.5H138V153.5H137.5H137V155.5H137.5ZM137.5 151.5H138V149.5H137.5H137V151.5H137.5ZM137.5 147.5H138V145.5H137.5H137V147.5H137.5ZM137.5 143.5H138V141.5H137.5H137V143.5H137.5ZM137.5 139.5H138V137.5H137.5H137V139.5H137.5ZM137.5 135.5H138V133.5H137.5H137V135.5H137.5ZM137.5 131.5H138V130.5H137.5H137V131.5H137.5Z"
          fill={currentBorderColor}
        />
        <path
          d="M67.5 20C67.5 23.4299 67.5 25.5 67.5 25.5C67.5 25.5 46.7611 25.5 36.5 25.5C26.2389 25.5 5.50004 25.5 5.50004 25.5C5.50004 25.5 5.5 23.4299 5.5 20C5.5 11.4396 19.3792 4.5 36.5 4.5C53.6208 4.5 67.5 11.4396 67.5 20Z"
          fill={currentFillColor}
          stroke={currentBorderColor}
          strokeDasharray="2 2"
        />
        <path
          d="M137.5 20C137.5 23.4299 137.5 25.5 137.5 25.5C137.5 25.5 116.761 25.5 106.5 25.5C96.2389 25.5 75.5 25.5 75.5 25.5C75.5 25.5 75.5 23.4299 75.5 20C75.5 11.4396 89.3792 4.5 106.5 4.5C123.621 4.5 137.5 11.4396 137.5 20Z"
          fill={currentFillColor}
          stroke={currentBorderColor}
          strokeDasharray="2 2"
        />
        <path d="M5.5 24.5H137.5V130.5H5.5V24.5Z" fill={currentFillColor} />
        <path
          d="M5.5 24.5H5V25.4815H5.5H6V24.5H5.5ZM5.5 27.4444H5V29.4074H5.5H6V27.4444H5.5ZM5.5 31.3704H5V33.3333H5.5H6V31.3704H5.5ZM5.5 35.2963H5V37.2593H5.5H6V35.2963H5.5ZM5.5 39.2222H5V41.1852H5.5H6V39.2222H5.5ZM5.5 43.1481H5V45.1111H5.5H6V43.1481H5.5ZM5.5 47.0741H5V49.037H5.5H6V47.0741H5.5ZM5.5 51H5V52.963H5.5H6V51H5.5ZM5.5 54.9259H5V56.8889H5.5H6V54.9259H5.5ZM5.5 58.8519H5V60.8148H5.5H6V58.8519H5.5ZM5.5 62.7778H5V64.7407H5.5H6V62.7778H5.5ZM5.5 66.7037H5V68.6667H5.5H6V66.7037H5.5ZM5.5 70.6296H5V72.5926H5.5H6V70.6296H5.5ZM5.5 74.5556H5V76.5185H5.5H6V74.5556H5.5ZM5.5 78.4815H5V80.4444H5.5H6V78.4815H5.5ZM5.5 82.4074H5V84.3704H5.5H6V82.4074H5.5ZM5.5 86.3333H5V88.2963H5.5H6V86.3333H5.5ZM5.5 90.2593H5V92.2222H5.5H6V90.2593H5.5ZM5.5 94.1852H5V96.1481H5.5H6V94.1852H5.5ZM5.5 98.1111H5V100.074H5.5H6V98.1111H5.5ZM5.5 102.037H5V104H5.5H6V102.037H5.5ZM5.5 105.963H5V107.926H5.5H6V105.963H5.5ZM5.5 109.889H5V111.852H5.5H6V109.889H5.5ZM5.5 113.815H5V115.778H5.5H6V113.815H5.5ZM5.5 117.741H5V119.704H5.5H6V117.741H5.5ZM5.5 121.667H5V123.63H5.5H6V121.667H5.5ZM5.5 125.593H5V127.555H5.5H6V125.593H5.5ZM5.5 129.518H5V130.5H5.5H6V129.518H5.5ZM137.5 130.5H138V129.519H137.5H137V130.5H137.5ZM137.5 127.556H138V125.593H137.5H137V127.556H137.5ZM137.5 123.63H138V121.667H137.5H137V123.63H137.5ZM137.5 119.704H138V117.741H137.5H137V119.704H137.5ZM137.5 115.778H138V113.815H137.5H137V115.778H137.5ZM137.5 111.852H138V109.889H137.5H137V111.852H137.5ZM137.5 107.926H138V105.963H137.5H137V107.926H137.5ZM137.5 104H138V102.037H137.5H137V104H137.5ZM137.5 100.074H138V98.1111H137.5H137V100.074H137.5ZM137.5 96.1481H138V94.1852H137.5H137V96.1481H137.5ZM137.5 92.2222H138V90.2593H137.5H137V92.2222H137.5ZM137.5 88.2963H138V86.3333H137.5H137V88.2963H137.5ZM137.5 84.3704H138V82.4074H137.5H137V84.3704H137.5ZM137.5 80.4444H138V78.4815H137.5H137V80.4444H137.5ZM137.5 76.5185H138V74.5556H137.5H137V76.5185H137.5ZM137.5 72.5926H138V70.6296H137.5H137V72.5926H137.5ZM137.5 68.6667H138V66.7037H137.5H137V68.6667H137.5ZM137.5 64.7407H138V62.7778H137.5H137V64.7407H137.5ZM137.5 60.8148H138V58.8519H137.5H137V60.8148H137.5ZM137.5 56.8889H138V54.9259H137.5H137V56.8889H137.5ZM137.5 52.963H138V51H137.5H137V52.963H137.5ZM137.5 49.0371H138V47.0741H137.5H137V49.0371H137.5ZM137.5 45.1111H138V43.1482H137.5H137V45.1111H137.5ZM137.5 41.1852H138V39.2223H137.5H137V41.1852H137.5ZM137.5 37.2593H138V35.2963H137.5H137V37.2593H137.5ZM137.5 33.3334H138V31.3704H137.5H137V33.3334H137.5ZM137.5 29.4075H138V27.4445H137.5H137V29.4075H137.5ZM137.5 25.4816H138V24.5H137.5H137V25.4816H137.5Z"
          fill={currentBorderColor}
        />
      </g>
      <path
        d="M137.5 93.1223H139.5C140.605 93.1223 141.5 94.0177 141.5 95.1223V103.122C141.5 104.227 140.605 105.122 139.5 105.122H137.5V93.1223Z"
        fill={token.colorBorder}
      />
      <defs>
        <filter
          id="filter0_ddd_24632_1102"
          x="0"
          y="0"
          width="143"
          height="200.244"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24632_1102" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_24632_1102" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_24632_1102" result="effect2_dropShadow_24632_1102" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_24632_1102" result="effect3_dropShadow_24632_1102" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_24632_1102" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default DessicantAirDryerMaintenanceWidget;
